import { render, staticRenderFns } from "./ElectricalContractSendMailModal.vue?vue&type=template&id=055e550e&scoped=true"
import script from "./ElectricalContractSendMailModal.vue?vue&type=script&lang=js"
export * from "./ElectricalContractSendMailModal.vue?vue&type=script&lang=js"
import style0 from "./ElectricalContractSendMailModal.vue?vue&type=style&index=0&id=055e550e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055e550e",
  null
  
)

export default component.exports